export const getCroppedImg = async (imageSrc, pixelCrop, bannerType) => {
	const image = new Image();
	image.src = imageSrc;

	const canvas = document.createElement('canvas');
	const ctx = canvas.getContext('2d');

	const outputWidth = bannerType?.width;
	const outputHeight = bannerType?.height;

	canvas.width = outputWidth;
	canvas.height = outputHeight;
	// Load the image and ensure it is fully loaded before drawing
	const loadImage = new Promise((resolve) => {
		image.onload = () => resolve();
	});

	await loadImage;

	ctx.drawImage(
		image,
		pixelCrop.x,
		pixelCrop.y,
		pixelCrop.width,
		pixelCrop.height,
		0,
		0,
		// pixelCrop.width,
		// pixelCrop.height
		outputWidth,
		outputHeight
	);

	return new Promise((resolve) => {
		canvas.toBlob((blob) => {
			resolve(blob);
		}, 'image/jpeg'); // Use 'image/jpeg' as default, but you can also detect image type if needed
	});
};

export const formatDate = (date) => {
	if (!(date instanceof Date) || isNaN(date)) {
		throw new Error('Invalid date');
	}

	const year = date.getFullYear();
	const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
	const day = String(date.getDate()).padStart(2, '0');

	return `${year}-${month}-${day}`;
};

export const getValidArray = (key) =>
	Array.isArray(key) && key.length > 0 ? key : null;

import { useRef } from 'react';
export const useDebounce = (callback, delay) => {
  const debounceTimeout = useRef(null);

  return (...args) => {
    if (debounceTimeout.current) {
      clearTimeout(debounceTimeout.current);
    }

    debounceTimeout.current = setTimeout(() => {
      callback(...args);
    }, delay);
  };
};

export const toTitleCase = (text) => {
	return text?.toLowerCase()?.split(" ")?.map((word) => {
		return word?.charAt(0)?.toUpperCase() + word?.slice(1);
	  })
	  .join(" ");
  };

  export const formatEpoch = (epoch, options = {}) => {
	if (!epoch) return '';
	
	// Convert to milliseconds if it's in seconds
	const timestamp = epoch.toString().length === 10 ? epoch * 1000 : epoch;

	const date = new Date(timestamp);
	
	// Customize date format using Intl.DateTimeFormat
	return new Intl.DateTimeFormat('en-IN', {
		year: 'numeric',
		month: 'short',
		day: '2-digit',
		...options,
	}).format(date);
};

export const parseToHumanDate = (input, options = {}) => {
	const {
	  locale = 'en-IN',
	  dateOptions = { year: 'numeric', month: 'short', day: '2-digit' },
	  timeOptions = { hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false },
	} = options;
  
	let dateObj;
	if (!input && input !== 0) throw new Error('No input provided');
  
	if (input instanceof Date) {
	  dateObj = input;
	} else if (typeof input === 'number' || /^[0-9]+$/.test(String(input))) {
	  const epoch = Number(input);
	  dateObj = new Date(String(epoch).length === 10 ? epoch * 1000 : epoch);
	} else if (typeof input === 'string') {
	  let s = input.trim();
	  s = s.replace(' ', 'T');
	  dateObj = new Date(s);
	  if (isNaN(dateObj)) {
		const match = s.match(/^(.+T\d{2}:\d{2}:\d{2})(\.\d+)?([+-]\d{2}:\d{2}|Z)?$/);
		if (match) {
		  const base = match[1];
		  const frac = match[2] ? match[2].slice(0, 4) : '';
		  const tz = match[3] || '';
		  dateObj = new Date(base + frac + tz);
		}
	  }
	} else {
	  throw new Error('Unsupported input type for parseToHuman');
	}
  
	if (!(dateObj instanceof Date) || isNaN(dateObj)) {
	  throw new Error('Unable to parse date input');
	}
  
	const dateStr = new Intl.DateTimeFormat(locale, dateOptions).format(dateObj);
	const timeStr = new Intl.DateTimeFormat(locale, timeOptions).format(dateObj);
	
	const now = new Date();
	const diffMs = now - dateObj;
	const abs = Math.abs(diffMs);
	const sec = Math.round(abs / 1000);
	const min = Math.round(abs / (1000 * 60));
	const hour = Math.round(abs / (1000 * 60 * 60));
	const day = Math.round(abs / (1000 * 60 * 60 * 24));
	const month = Math.round(abs / (1000 * 60 * 60 * 24 * 30));
	const year = Math.round(abs / (1000 * 60 * 60 * 24 * 365));
  
	let relative;
	const past = diffMs > 0;
  
	if (sec < 45) relative = past ? 'just now' : 'in a few seconds';
	else if (sec < 90) relative = past ? 'a minute ago' : 'in a minute';
	else if (min < 45) relative = past ? `${min} minutes ago` : `in ${min} minutes`;
	else if (min < 90) relative = past ? 'an hour ago' : 'in an hour';
	else if (hour < 24) relative = past ? `${hour} hours ago` : `in ${hour} hours`;
	else if (hour < 42) relative = past ? 'yesterday' : 'tomorrow';
	else if (day < 30) relative = past ? `${day} days ago` : `in ${day} days`;
	else if (month < 12) relative = past ? `${month} months ago` : `in ${month} months`;
	else relative = past ? `${year} years ago` : `in ${year} years`;
  
	return {
	  date: dateStr,
	  time: timeStr,
	  relative,
	  iso: dateObj.toISOString(),
	  rawDate: dateObj,
	};
  };
  
  //function to format number with commas
  export const formatNumberWithCommas = (number) => {
	return number.toLocaleString('en-IN');
  };